import { COR_ICONE_TOM, FUNDO_TOM, marcadorMinhaResposta } from "@/modules/escala/format";
import { Hourglass } from "lucide-react";
import type { ParticipanteDetalhe } from "@/modules/escala/services/escalaService";

interface FaixaMinhaParticipacaoProps {
  /** A linha da própria pessoa (`ehPropria`) com resposta visível. */
  participante: ParticipanteDetalhe;
  /** Escala ativa e ainda por acontecer — só então dá para responder (o banco recusa depois). */
  podeResponder: boolean;
  onResponder: () => void;
}

/**
 * "Sua participação" em destaque, no topo da escala: o que a pessoa já
 * respondeu ou, se falta responder, o botão para isso. Só reflete o que o
 * banco gravou; não aparece em escala cancelada (a resposta fica no cartão da
 * própria pessoa, dentro da equipe).
 */
export function FaixaMinhaParticipacao({ participante, podeResponder, onResponder }: FaixaMinhaParticipacaoProps) {
  if (!participante.resposta) return null;
  const pendente = participante.resposta === "PENDENTE";
  const marcador = marcadorMinhaResposta(participante.resposta, participante.origemResposta);
  // Pendente e sem como responder (a escala já passou): não afirma que "aguarda" algo que não dá mais para fazer.
  const semResposta = pendente && !podeResponder;
  const Icone = semResposta ? Hourglass : marcador.icone;
  const tom = semResposta ? "off" : marcador.tom;
  const titulo = semResposta ? "Sem resposta registrada" : marcador.texto;

  return (
    <div className={`flex items-center gap-3 rounded-2xl p-3.5 ${FUNDO_TOM[tom]}`}>
      <span aria-hidden className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-surface">
        <Icone size={20} className={COR_ICONE_TOM[tom]} />
      </span>
      <div className="flex min-w-0 flex-1 flex-col">
        <p className="text-[14.5px] font-bold leading-tight text-text">{titulo}</p>
        {participante.funcaoNome && (
          <p className="text-[13px] text-muted">Sua função: {participante.funcaoNome}</p>
        )}
      </div>
      {pendente && podeResponder && (
        <button
          type="button"
          onClick={onResponder}
          className="min-h-11 shrink-0 rounded-xl bg-primary px-4 text-sm font-semibold text-on-primary transition-colors hover:bg-primary-hover"
        >
          Responder
        </button>
      )}
    </div>
  );
}
